import { render } from "./SurvivalChart.vue?vue&type=template&id=a7a37120&scoped=true"
import script from "./SurvivalChart.vue?vue&type=script&lang=js"
export * from "./SurvivalChart.vue?vue&type=script&lang=js"

import "./SurvivalChart.vue?vue&type=style&index=0&id=a7a37120&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7a37120"]])

export default __exports__